import {combineReducers} from 'redux';
import menu from './menu';
import signUp from './signUp';
import security from './security';
import datosGenerales from './datosGeneralesReducer';
import nuevoTarifario from './nuevoTarifario';
import medio from './medioReducer';

const allReducers = combineReducers({
    menu,
    signUp,
    security,
    datosGenerales,
    nuevoTarifario,
    medio
});

export default allReducers;